"use strict"
export const PdfExportConfig = {
    defaultHorizontalPadding: 0.75,
    labelHorizontalPadding: 0.5, 
    headerVerticalPadding: 1, // vertical padding for header cells
    documentMargins: { top: 20, left: 15, bottom: 10, right: 15 }
    // jsPDF, exportDataGrid werden in index.js gesetzt
}

export function ExportToPdf(grid, erhebungDaten, mitgliedNummer) {
    let ret = null;
    if (!CONFIG.smallSurveyForGuests || CONFIG.memberStatusCode === 'M') {
        ret = exportGridToPdf(grid, erhebungDaten, mitgliedNummer);
    } else {
        ret = exportGastmitglied2Pdf(erhebungDaten, mitgliedNummer);
    }
    return ret;
}
function exportGastmitglied2Pdf(erhebungDaten, mitgliedNummer) {
    const doc = new jsPDF({
        putOnlyUsedFonts: true
    });
    const fontName = doc.getFont().fontName;
    const pages = doc.internal.getNumberOfPages();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // header
    const header = `Personalbestandserhebung ${erhebungDaten.jahr} Gastmitglied`;
    doc.setFont(fontName, "", "bold");
    doc.setFontSize(14);
    const headerWidth = doc.getTextDimensions(header).w;
    doc.text(header, (pageWidth - headerWidth) / 2, 14);
    // footer
    let footer = `Stand: ${new Date(erhebungDaten.datum).toLocaleString("de-de", { timeStyle: "medium", dateStyle: "medium" })} / Bearbeiter: ${erhebungDaten.bearbeiter ?? "<k.A.>"} für KAV-Mitglied ${mitgliedNummer}`;
    doc.setFont(fontName, "", "normal");
    doc.setFontSize(9);
    let footerWidth = doc.getTextDimensions(footer).w;
    doc.setTextColor('#222222');
    doc.text(footer, (pageWidth - footerWidth) / 2, pageHeight - 16);
    // Text
    doc.setFontSize(12);
    const leftText = 75;
    const leftValue = leftText + 45;
    let y = 60;
    doc.text("Beschäftigte", leftText, y);
    doc.text(erhebungDaten.gast_Angestellte.toString(), leftValue, y);
    y += 10;
    doc.text("Auszubildende", leftText, y);
    doc.text(erhebungDaten.gast_Azubis.toString(), leftValue, y);
    y += 10;
    doc.text("Gesamt", leftText, y);
    doc.text(erhebungDaten.gast_Gesamt.toString(), leftValue, y);

    return doc.save(`Personalbestandserhebung ${erhebungDaten.jahr}.pdf`, { returnPromise: true });
}
async function exportGridToPdf(gridComponent, erhebungDaten, mitgliedNummer) {
    const doc = new jsPDF({ // 
        unit: 'mm', format: 'a4', // => defaults
        orientation: 'landscape',
        putOnlyUsedFonts: true
    });
    doc.mwitc = { calculate: true };
    const lastPoint = { x: 0, y: 0 };
    await DevExpress.pdfExporter.exportDataGrid({
        jsPDFDocument: doc,
        component: gridComponent,
        //margin: { top: 20, left: 15, bottom: 10, right: 15 },
        margin: PdfExportConfig.documentMargins,
        // Reihenfolge des Aufrufs der Callbacks:
        // - erst für alle Zellen customizeCell
        // - dann für alle Spalten onRowExporting
        // - und zuletzt für alle Zellen customDrawCell
        customizeCell(options) {
            pdfCellCustomizeErhebungGrid(options);
        },
        customDrawCell(options) {
            const { rect, gridCell, pdfCell, doc } = options;
            if (gridCell.rowType === 'header' && gridCell.column.mwitc != null) {
                options.cancel = true; // Header-Zellen nicht zeichnen lassen, wir zeichnen sie hier selbst
                calculateTextMetrics(doc);
                // Text ermitteln und ggf. umbrechen
                const text = (gridCell.column.mwitc.labeltext ?? gridCell.column.caption).replaceAll("&shy;", "");
                const textlines = doc.splitTextToSize(text, rect.h - 2 * PdfExportConfig.headerVerticalPadding);
                // Text rotiert zentriert in die Header-Zelle schreiben
                const textHeight = doc.mwitc.headerLineHeight * textlines.length + (textlines.length == 1 ? 0 : doc.mwitc.headerSpacingHeight * (textlines.length - 1));
                const remainingWidth = rect.w - textHeight;
                const xOffset = remainingWidth / 2 + doc.mwitc.headerLineHeight;
                doc.text(textlines, rect.x + xOffset, rect.y + rect.h - PdfExportConfig.headerVerticalPadding, { align: "left", angle: 90 })
            }
            // "unteres Ende" der Tabelle für den zu druckenden Fuß ermitteln
            if (lastPoint.x < rect.x + rect.w) {
                lastPoint.x = rect.x + rect.w;
            }
            if (lastPoint.y < rect.y + rect.h) {
                lastPoint.y = rect.y + rect.h;
            }
        }
    });
    if (SurveyHooks.onPdfRequestAdditionalPages) {
        SurveyHooks.onPdfRequestAdditionalPages(doc);
    }
    const fontName = doc.getFont().fontName;
    const pages = doc.internal.getNumberOfPages();
    // header
    const header = `Personalbestandserhebung ${erhebungDaten.jahr}`;
    const pageWidth = doc.internal.pageSize.getWidth();
    const headerWidth = doc.getTextDimensions(header).w;

    for (let i = 1; i <= pages; i++) {
        doc.setPage(i);
        doc.setFont(fontName, "", "bold");
        doc.setFontSize(14);
        doc.text(header, (pageWidth - headerWidth) / 2, 14);
        // footer
        let footer = `Stand: ${new Date(erhebungDaten.datum).toLocaleString("de-de", { timeStyle: "medium", dateStyle: "medium" })} / Bearbeiter: ${erhebungDaten.bearbeiter ?? "<k.A.>"} für KAV-Mitglied ${SurveyRuntime.mitgliedNummer} / Seite ${i}`;
        let footerWidth = doc.getTextDimensions(footer).w;
        doc.setFont(fontName, "", "normal");
        doc.setFontSize(9);
        doc.setTextColor('#222222');
        doc.text(footer, (lastPoint.x - footerWidth), lastPoint.y + 10);
    }
    await doc.save(`Personalbestandserhebung ${erhebungDaten.jahr}.pdf`, { returnPromise: true });
}

function calculateTextMetrics(doc) {
    if (doc.mwitc.calculate) {
        doc.mwitc.calculate = false;
        const dim1line = doc.getTextDimensions("AQ");
        const dim2lines = doc.getTextDimensions(["AQ", "AQ"]);
        doc.mwitc.headerLineHeight = dim1line.h;
        doc.mwitc.headerSpacingHeight = dim2lines.h - 2 * dim1line.h;
        //console.log("Text-Metriken für PDF-Export:", doc.mwitc);
    }
}

function pdfCellCustomizeErhebungGrid({ gridCell, pdfCell }) {
    const column = gridCell.column;
    const dataField = column.dataField;
    pdfCell.borderColor = "#000000";
    pdfCell.textColor = "#000000";

    // Ränder schmaler
    pdfCell.padding.left = PdfExportConfig.defaultHorizontalPadding;
    pdfCell.padding.right = PdfExportConfig.defaultHorizontalPadding;

    if (gridCell.rowType === 'header') {
        if (column.mwitc && column.mwitc.labeltext) {
            pdfCell.text = column.mwitc.labeltext;
        }
        if (pdfCell.text === "Gesamtsumme") pdfCell.text = "Gesamt"; // HÄSSLICH!
        if (gridCell.column.isBand) {   // die ersten beiden Zeilen (= "Über"header)
            pdfCell.horizontalAlign = "center"
        } else {
            pdfCell.horizontalAlign = "left"
            // Umbruch
            pdfCell.wordWrapEnabled = true;
        }
    } else if (gridCell.rowType === 'data') {
        switch (dataField) {
            //case 'shortName':
            //    break;
            case 'label':
                // Ränder noch schmaler
                pdfCell.padding.left = PdfExportConfig.labelHorizontalPadding;
                pdfCell.padding.right = PdfExportConfig.labelHorizontalPadding;
                // Text ohne HTML
                pdfCell.text = gridCell.data.labeltext;
                // Umbruch
                pdfCell.wordWrapEnabled = true;
                break;
        }
        //console.log(gridCell)
        if (gridCell.value === -1) {
            pdfCell.backgroundColor = "#C0C0C0";
        }
    }
}


